/* ========================================================================
   On document ready do stuff
 ========================================================================== */

util.onDocumentReady(function () {
  const body = document.getElementById('body');

  // Set frontend version
  util.frontEndVersion = body.dataset.version;

  // Set debug mode
  util.debugMode = body.dataset.debugMode === 'true';

  // Set culture
  util.uiCulture = body.dataset.culture;

  // Set language
  util.uiLanguage = util.uiCulture ? util.uiCulture.split('-')[0] : null;

  // Set homepage Id
  util.homePageId = body.dataset.homepageId;

  // Set path
  util.path = body.dataset.path;

  if (util.debugMode) {
    console.info(util.uiCulture, util.uiLanguage, util.homePageId, util.path);
    if (!util.uiCulture) console.error('Culture is not set');
    if (!util.uiLanguage) console.error('Language is not set');
    if (!util.homePageId) console.error('HomePageId is not set');
    if (!util.path) console.error('Path is not set');
  }

  // Enable transitions
  document.documentElement.classList.remove('preloadTransitions');

  // Pristine config
  app.pristineConfig = {
    // class of the parent element where the error/success class is added
    classTo: 'form__group',
    errorClass: 'has-error',
    successClass: 'has-success',
    // class of the parent element where error text element is appended
    errorTextParent: 'form__group',
    // type of element to create for the error text
    errorTextTag: 'div',
    // class of the error text element
    errorTextClass: 'form__validation',
    locale: 'nl',
  };

  // Enable SVG in IE11
  // svg4everybody();

  app.general.initAppHeight();
  // app.general.initTouch();
  app.navigation.init();
  // app.navigation.initSearchBox();
  // app.general.initEmailLinks();
  // app.general.initLax();
  app.cookiePopup.init();
  // app.dataLayer.init();

  const min = util.debugMode === false ? '.min' : '';

  // Dynamically load scripts: https://github.com/malko/l.js
  // if (document.querySelectorAll('[data-generic-form]').length > 0) {
  //   ljs.load(
  //     util.getVersionedUrl('/scripts/dist/loadingOverlay' + min + '.js'),
  //     util.getVersionedUrl('/scripts/dist/aspnet-validation' + min + '.js'),
  //     util.getVersionedUrl('/scripts/dist/forms.validation' + min + '.js'),
  //     util.getVersionedUrl('/scripts/dist/forms.generic' + min + '.js'),
  //     () => {
  //       app.genericForm.init();
  //     }
  //   );
  // }

  if (document.querySelectorAll('[data-toast-message]').length > 0) {
    // show toast messages (with delay)
    const toastMessages = document.querySelectorAll('[data-toast-message]');
    toastMessages.forEach((message, index) => {
      window.setTimeout(() => {
        Toast(message.innerHTML, message.dataset.toastType.toLowerCase(), message.dataset.toastTimeout ?? 7500);
      }, index * 1000);
    });
  }

  if (document.querySelectorAll('[data-quicknav]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.quickNav' + min + '.js'), () => {
      app.quickNav.init();
    });
  }

  if (document.querySelectorAll('[data-sidebar-nav]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.sidebarNav' + min + '.js'), () => {
      app.sidebarNav.init();
    });
  }

  // if (document.querySelectorAll('[data-video-lightbox]').length > 0) {
  //   ljs.load(util.getVersionedUrl('/scripts/dist/videoLightbox' + min + '.js'), () => {
  //     const videos = document.querySelectorAll('[data-video-lightbox]');
  //     VideoLightbox(videos);
  //   });
  // }

  if (document.querySelectorAll('[data-accordion-list]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.accordion' + min + '.js'), () => {
      app.accordion.init();
    });
  }

  if (
    document.querySelectorAll('[data-carousel]').length > 0 ||
    document.querySelectorAll('[data-logo-carousel]').length > 0 ||
    document.querySelectorAll('[data-image-carousel]').length > 0
  ) {
    ljs.load(
      util.getVersionedUrl('/scripts/dist/embla' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/embla-carousel-autoplay' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/modules.carousel' + min + '.js'),
      () => {
        app.carousel.init();
      }
    );
  }

  if (document.querySelectorAll('[data-step-carousel-1]').length > 0) {
    ljs.load(
      util.getVersionedUrl('/scripts/dist/embla' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/embla-carousel-auto-height' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/modules.carousel' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/modules.stepByStep' + min + '.js'),
      () => {
        app.stepByStep.init();
      }
    );
  }

  if (document.querySelectorAll('[data-video]').length > 0) {
    ljs.load(
      'https://player.vimeo.com/api/player.js',
      util.getVersionedUrl('/scripts/dist/modules.videos' + min + '.js'),
      () => {
        app.videos.init();
      }
    );
  }

  if (document.querySelectorAll('[data-locations]').length > 0) {
    ljs.load(
      'https://unpkg.com/mustache@4.2.0/mustache' + min + '.js',
      util.getVersionedUrl('/scripts/dist/jsonpath' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/modules.locations' + min + '.js'),
      () => {
        app.locations.init();
      }
    );
  }

  if (document.querySelectorAll('[data-news-listing]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.newsListing' + min + '.js'), () => {
      app.newsListing.init();
    });
  }

  if (document.querySelectorAll('[data-contact-section]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.contactSection' + min + '.js'), () => {
      app.contactSection.init();
    });
  }

  if (document.querySelectorAll('[data-hyvor-chat]').length > 0) {
    ljs.load(
      // util.getVersionedUrl('module:https://talk.hyvor.com/embed/embed.js'),
      util.getVersionedUrl('/scripts/dist/modules.hyvor' + min + '.js'),
      () => {
        app.hyvor.init();
      }
    );
  }

  if (document.querySelectorAll('[data-topics]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.topics' + min + '.js'), () => {
      app.topics.init();
    });
  }

  if (document.querySelectorAll('[data-emergency-banner]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.emergencyBanner' + min + '.js'), () => {
      app.emergencyBanner.init();
    });
  }

  // Scroll to form success message
  if (document.querySelector('#umbraco-forms-form-submitted')) {
    setTimeout(() => {
      document.querySelector('#umbraco-forms-form-submitted').scrollIntoView();
    }, 500);
  }

  // if (document.querySelectorAll('[data-lax]').length > 0) {
  //   ljs.load(
  //     util.getVersionedUrl('/scripts/dist/lax' + min + '.js'),
  //     util.getVersionedUrl('/scripts/dist/modules.lax' + min + '.js'),
  //     () => {
  //       app.lax.init();
  //     }
  //   );
  // }
});
